import { EScrollUpButtonType } from '../types';
import { ETestIds } from '../../../../constants/testIds';

export const getDataTestIdByType = (type: EScrollUpButtonType) => {
  switch (type) {
    case 'filters':
      return ETestIds.RootMortgageWrapper;
    case 'up':
      return ETestIds.OfferListContainer;

    default:
      return ETestIds.OfferListContainer;
  }
};
